var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 13.852v1.84h7.91v-7.84H10a6.005 6.005 0 0 0-6 6zM4 17.692h7.91v9.75H4zM4 29.442h7.91v9.76H4zM4 43.042a6.011 6.011 0 0 0 6 6h1.91v-7.84H4zM56.94 13.852a6.005 6.005 0 0 0-6-6h-1.91v7.84h7.91zM49.03 17.692h7.91v9.75h-7.91zM56.94 29.442h-7.91v3.45a12.55 12.55 0 0 1 7.91 2.53zM47.03 33.102V7.852H13.91v41.19h23.27a12.712 12.712 0 0 1 9.85-15.94zm-22.08 5.95a4.003 4.003 0 0 1-3.97-3.98v-13.25a3.993 3.993 0 0 1 6.01-3.41l11.05 6.63a3.995 3.995 0 0 1 0 6.8l-11.05 6.63a3.996 3.996 0 0 1-2.04.58z",
    fill: "#c89c50",
    opacity: 1,
    "data-original": "#c89c50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.01 26.762-11.05-6.63a1.975 1.975 0 0 0-2.98 1.69v13.25a1.982 1.982 0 0 0 2.98 1.69l11.05-6.63a1.983 1.983 0 0 0 0-3.37zM49.34 34.882a10.67 10.67 0 0 0-10.66 10.66c.583 14.143 20.74 14.139 21.32 0a10.67 10.67 0 0 0-10.66-10.66zm-.24 3.66a1.48 1.48 0 0 1 0 2.96 1.48 1.48 0 0 1 0-2.96zm1.68 14H47.9a1 1 0 0 1 0-2h.44v-5.79c-.704.083-1.424-.194-1.44-1a1.003 1.003 0 0 1 1-1h1.44a1.003 1.003 0 0 1 1 1v6.79h.44a1 1 0 0 1 0 2z",
    fill: "#c89c50",
    opacity: 1,
    "data-original": "#c89c50",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoInfo);
export default __webpack_public_path__ + "static/media/video_info.ff8c01b04af207a1900f41524e3a6fe3.svg";
export { ForwardRef as ReactComponent };